/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Invalid/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Invalid({
  children,
  viewPath = "/App/Form/Data/ProvideData/PatientFirstName/Status/Invalid"
  
}) {
  return (<React.Fragment
>
<span
  data-testid="Invalid.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
Make sure the name is longer than one letter and doesn't contain special characters
</span>
{children}
</React.Fragment>)
}